var map = {
	"./Intro/intro.md": 1097,
	"./Overview/introAccessibility.md": 1098,
	"./Overview/introConsistency.md": 1099,
	"./Overview/introOverview.md": 1100,
	"./Overview/introRestraint.md": 1101,
	"./Palette/paletteOverview.md": 1102,
	"./Tokens/Background/altBackground.md": 1103,
	"./Tokens/Background/appBackground.md": 1104,
	"./Tokens/Background/backgroundColors.md": 1105,
	"./Tokens/Background/overlayBackground.md": 1106,
	"./Tokens/Background/uiBackground.md": 1107,
	"./Tokens/Border/borders.md": 1108,
	"./Tokens/Brand/common.md": 1109,
	"./Tokens/Common/brand.md": 1110,
	"./Tokens/Expressive/blue.md": 1111,
	"./Tokens/Expressive/expressive.md": 1112,
	"./Tokens/Expressive/green.md": 1113,
	"./Tokens/Expressive/orange.md": 1114,
	"./Tokens/Expressive/pink.md": 1115,
	"./Tokens/Expressive/purple.md": 1116,
	"./Tokens/Expressive/red.md": 1117,
	"./Tokens/Expressive/teal.md": 1118,
	"./Tokens/Expressive/yellow.md": 1119,
	"./Tokens/Intent/errorIntent.md": 1120,
	"./Tokens/Intent/informationIntent.md": 1121,
	"./Tokens/Intent/intents.md": 1122,
	"./Tokens/Intent/successIntent.md": 1123,
	"./Tokens/Intent/warningIntent.md": 1124,
	"./Tokens/Neutral/neutrals.md": 1125,
	"./Tokens/Primary/primary.md": 1126,
	"./Tokens/State/stateColors.md": 1127,
	"./Tokens/Text/text.md": 1128,
	"./Tokens/tokensCore.md": 1129,
	"./Tokens/tokensOverview.md": 1130,
	"./Tokens/tokensSemantic.md": 1131
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1096;